import React, {FC, PropsWithChildren, ReactNode} from 'react';

import {TooltipCoordinator} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipCoordinator';
import {TooltipOverflowCondition} from '../../../../../libs/shared/ui/src/components/tooltips/tooltipOverflowCondition';
import {MultilineTooltipOverflowCondition} from '../../../common/tooltips/multilineTooltipOverflowCondition';
import {ContactCardSectionItem} from './contactCardSectionItem';

/*
 * Props.
 */

interface ContactCardChildItemProps {
  text: string;
  copyText?: string;
  title?: ReactNode;
  shouldAllowMultiLineWrapping?: boolean;
}

/*
 * Component.
 */

export const ContactCardChildItem: FC<PropsWithChildren<ContactCardChildItemProps>> = (props) => {
  const {text, copyText, title, children, shouldAllowMultiLineWrapping} = props;
  return (
    <ContactCardSectionItem title={title} copyInfo={copyText ?? text}>
      <TooltipCoordinator placement="top" render={() => text}>
        {renderContentWithOverflow(children, Boolean(shouldAllowMultiLineWrapping))}
      </TooltipCoordinator>
    </ContactCardSectionItem>
  );
};

/*
 * Helpers.
 */

function renderContentWithOverflow(content: ReactNode, shouldAllowMultiLineWrapping: boolean) {
  if (shouldAllowMultiLineWrapping) {
    return <MultilineTooltipOverflowCondition lines={3}>{content}</MultilineTooltipOverflowCondition>;
  }
  return <TooltipOverflowCondition>{content}</TooltipOverflowCondition>;
}
